// import React, { useEffect, useState } from 'react';
// import '../DescriptionBox/DescriptionBox.css';

// const DescriptionBox = ({ product }) => {
//   const [tab, setTab] = useState('description');
//   const [reviews, setReviews] = useState([]);
//   const [form, setForm] = useState({ name: '', rating: 5, text: '' });
//   const [loading, setLoading] = useState(false);

//   const token = localStorage.getItem("auth-token");

//   // -------------------------------
//   // ✅ Load Reviews
//   // -------------------------------
//   useEffect(() => {
//     if (!product) return;

//     const loadReviews = async () => {
//       const res = await fetch(`${BASE_URL}/product/${product.product_id}/reviews`);
//       const data = await res.json();
//       if (data.success) setReviews(data.reviews);
//     };

//     loadReviews();
//   }, [product]);


//   // -------------------------------
//   // ✅ Submit Review
//   // -------------------------------
//   const submitReview = async (e) => {
//     e.preventDefault();

//     if (!token) {
//       alert("⚠ You must login to post a review.");
//       return;
//     }

//     if (!form.text || !form.rating) {
//       return alert('Please write your review and select a rating');
//     }

//     setLoading(true);

//     const res = await fetch(`${BASE_URL}/product/${product.product_id}/reviews`, {
//       method: 'POST',
//       headers: { 
//         'Content-Type': 'application/json',
//         'auth-token': token        
//       },
//       body: JSON.stringify(form)
//     });

//     const data = await res.json();
//     setLoading(false);

//     if (data.success) {
//       setForm({ name: '', rating: 5, text: '' });

//       // 🔄 Reload reviews again
//       const reload = await fetch(`${BASE_URL}/product/${product.product_id}/reviews`);
//       const reloadData = await reload.json();
//       if (reloadData.success) setReviews(reloadData.reviews);

//       setTab('reviews');
//     } else {
//       alert(data.error || 'Failed to post review');
//     }
//   };


//   return (
//     <div className='descriptionbox'>

//       {/* ------------------ */}
//       {/* Tabs */}
//       {/* ------------------ */}
//       <div className="descriptionbox-navigator">
//         <div
//           className={`descriptionbox-nav-box ${tab === 'description' ? '' : 'fade'}`}
//           onClick={() => setTab('description')}
//         >
//           Description
//         </div>

//         <div
//           className={`descriptionbox-nav-box ${tab === 'reviews' ? '' : 'fade'}`}
//           onClick={() => setTab('reviews')}
//         >
//           Reviews ({reviews.length})
//         </div>
//       </div>


//       {/* ------------------ */}
//       {/* Description TAB */}
//       {/* ------------------ */}
//       {tab === 'description' ? (
//         <div className="descriptionbox-description">
//           <p>{product.description || 'No description available.'}</p>
//         </div>
//       ) : (
        
//         // ----------------------------
//         // Reviews TAB
//         // ----------------------------
//         <div className="descriptionbox-reviews">

//           {/* Reviews List */}
//           <div className="reviews-list">
//             {reviews.length === 0 && <p>No reviews yet — be the first!</p>}

//             {reviews.map((r) => (
//               <div key={r._id} className="review-item">
//                 <div className="review-head">
//                   <strong>{r.name || "Anonymous"}</strong>
//                   <span className="rating">
//                     {'★'.repeat(r.rating)}{'☆'.repeat(5 - r.rating)}
//                   </span>
//                 </div>

//                 <div className="review-body">{r.text}</div>
//                 <div className="review-date">
//                   {new Date(r.date).toLocaleString()}
//                 </div>
//               </div>
//             ))}
//           </div>


//           {/* ---------------------------- */}
//           {/* Review Form */}
//           {/* ---------------------------- */}
//           <div className="review-form">
//             <h3>Write a Review</h3>

//             {!token && (
//               <p style={{ color: "red", marginBottom: "10px" }}>
//                 You must login to write a review.
//               </p>
//             )}

//             <form onSubmit={submitReview}>
//               <input
//                 placeholder="Your name (optional)"
//                 value={form.name}
//                 onChange={(e) => setForm({ ...form, name: e.target.value })}
//               />

//               <select
//                 value={form.rating}
//                 onChange={(e) =>
//                   setForm({ ...form, rating: Number(e.target.value) })
//                 }
//               >
//                 <option value={5}>⭐⭐⭐⭐⭐ Excellent</option>
//                 <option value={4}>⭐⭐⭐⭐ Good</option>
//                 <option value={3}>⭐⭐⭐ Average</option>
//                 <option value={2}>⭐⭐ Poor</option>
//                 <option value={1}>⭐ Terrible</option>
//               </select>

//               <textarea
//                 placeholder="Write your review..."
//                 value={form.text}
//                 onChange={(e) => setForm({ ...form, text: e.target.value })}
//               />

//               <button type="submit" disabled={loading || !token}>
//                 {loading ? 'Posting...' : 'Post Review'}
//               </button>
//             </form>
//           </div>

//         </div>
//       )}
//     </div>
//   );
// };

// export default DescriptionBox;
import React, { useEffect, useState } from 'react';
import '../DescriptionBox/DescriptionBox.css';
import BASE_URL from '../../Config/api';
const DescriptionBox = ({ product }) => {
  const [tab, setTab] = useState('description');
  const [reviews, setReviews] = useState([]);
  const [form, setForm] = useState({ name: '', rating: 5, text: '' });
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("auth-token");

  // Load reviews
  useEffect(() => {
    if (!product) return;
    const loadReviews = async () => {
      const res = await fetch(`${BASE_URL}/product/${product.product_id}/reviews`);
      const data = await res.json();
      if (data.success) setReviews(data.reviews);
    };
    loadReviews();
  }, [product]);

  // Submit review
  const submitReview = async (e) => {
    e.preventDefault();
    if (!token) return alert("⚠ You must login to post a review.");
    if (!form.text || !form.rating) return alert('Please write your review and select a rating');

    setLoading(true);

    const res = await fetch(`${BASE_URL}/product/${product.product_id}/reviews`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'auth-token': token },
      body: JSON.stringify(form)
    });

    const data = await res.json();
    setLoading(false);

    if (data.success) {
      setForm({ name: '', rating: 5, text: '' });

      const reload = await fetch(`${BASE_URL}/product/${product.product_id}/reviews`);
      const reloadData = await reload.json();
      if (reloadData.success) setReviews(reloadData.reviews);

      setTab('reviews');
    } else alert(data.error || 'Failed to post review');
  };

  return (
    <div className='descriptionbox'>

      {/* Tabs */}
      <div className="descriptionbox-navigator">
        <div
          className={`descriptionbox-nav-box ${tab === 'description' ? 'active' : ''}`}
          onClick={() => setTab('description')}
        >
          Description
        </div>

        <div
          className={`descriptionbox-nav-box ${tab === 'reviews' ? 'active' : ''}`}
          onClick={() => setTab('reviews')}
        >
          Reviews ({reviews.length})
        </div>
      </div>

      {/* Description Tab */}
      {tab === 'description' && (
        <div className="descriptionbox-description fade-in">
          <p>{product.description || 'No description available.'}</p>
        </div>
      )}

      {/* Reviews Tab */}
      {tab === 'reviews' && (
        <div className="descriptionbox-reviews fade-in">

          {/* Reviews List */}
          <div className="reviews-list">
            {reviews.length === 0 && <p className="no-review">No reviews yet — be the first!</p>}
            {reviews.map((r) => (
              <div key={r._id} className="review-item">
                <div className="review-head">
                  <strong>{r.name || "Anonymous"}</strong>
                  <span className="rating">
                    {'★'.repeat(r.rating)}{'☆'.repeat(5 - r.rating)}
                  </span>
                </div>
                <div className="review-body">{r.text}</div>
                <div className="review-date">{new Date(r.date).toLocaleDateString()}</div>
              </div>
            ))}
          </div>

          {/* Review Form */}
          <div className="review-form">
            <h3>Write a Review</h3>
            {!token && <p className="login-warning">You must login to write a review.</p>}

            <form onSubmit={submitReview}>
              <input
                placeholder="Your name (optional)"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
              />

              <select
                value={form.rating}
                onChange={(e) => setForm({ ...form, rating: Number(e.target.value) })}
              >
                <option value={5}>⭐⭐⭐⭐⭐ Excellent</option>
                <option value={4}>⭐⭐⭐⭐ Good</option>
                <option value={3}>⭐⭐⭐ Average</option>
                <option value={2}>⭐⭐ Poor</option>
                <option value={1}>⭐ Terrible</option>
              </select>

              <textarea
                placeholder="Write your review..."
                value={form.text}
                onChange={(e) => setForm({ ...form, text: e.target.value })}
              />

              <button type="submit" disabled={loading || !token}>
                {loading ? 'Posting...' : 'Post Review'}
              </button>
            </form>
          </div>

        </div>
      )}

    </div>
  );
};

export default DescriptionBox;
